/**
 * @param $resource
 * @param apiRequestParams
 * @param {AppConfig} appConfig
 */
const ProductAvailabilityResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'productsavailability/',
        Object.assign(
            apiRequestParams.defaults()
        ),
        {}
    );
};

module.exports = ProductAvailabilityResource;
